import {combineReducers} from 'redux';
import {getUsersReducer} from './getUsers'
import {createLawRed } from './createLawRed';
const reducer = combineReducers({
   createLawRed,getUsersReducer 
    });
    
    export default reducer;
